import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Form,
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import DateTime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import AsyncSelect from 'react-select/async'
import NumberFormat from 'react-number-format'
import Iframe from 'react-iframe'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import ReactSelect from 'components/Form/Select/Select'
import useForm from "lib/useForm"
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import {homepage} from '../../../../package.json';

const formSwal = withReactContent(Swal)

const inicialResumo = {
  quantidade: 0,
  valor:      0,
  ticket:     0,
}

const Atendimento = () => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm([])

  const [loading, setLoading]                   = useState(true)
  const [loadingTabela, setLoadingTabela]       = useState(false)
  const [lojas, setLojas]                       = useState([])
  const [categorias, setCategorias]             = useState([])
  const [fornecedores, setFornecedores]         = useState([])
  const [vendedores, setVendedores]             = useState([])
  const [listaAtendimento, setListaAtendimento] = useState([])
  const [resumo, setResumo]                     = useState(inicialResumo)
  const [divResumo, setdivResumo]               = useState('d-none')
  const [pathPDF, setPathPDF]                   = useState('')
  const [modalPrint, setModalPrint]             = useState(false)

  const colunas = [
    {
      dataField: 'horario',
      text: 'Horário',
      headerStyle: { cursor: 'text' },
      formatter: (cellContent, row) => { return(cellContent+" hs")}
    },
    {
      dataField: 'qtd',
      text: 'Atendimento',
      headerStyle: { cursor: 'text' },
      // sort: true
    },
    {
      dataField: 'total_vendas',
      text: 'Vendas',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'ticket',
      text: 'Ticket Médio',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    }
  ]
  
  const listaLojas = () => {
    let lista = [{id: 0, title: 'TODAS'}]
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setLojas(lista)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const listarCategorias = () => {
    const url     = rotas.categoriaSelect;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setCategorias(lista);
      }
      setLoading(false)
    })
  }

  const listarFornecedores = () => {
    const url     = rotas.fornecedorProduto
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
      let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setFornecedores(lista);
      }
      setLoading(false)
    })
  }

  const pesquisaProduto = (produto) => {
    if (produto.length >= 3) {
      const url = rotas.filtroProdutoRelatorio;
      const retorno = rest.get(url + '?produto=' + produto);
      let rProdutos = [];
      return retorno.then(ret => {
        ret.lista.map(produto =>{
          rProdutos.push({ value: produto.produto_id, label: produto.produto, cod_barras: produto.cod_barras || '' })
      })
      return (rProdutos);
    })
    }
  }

  const listarVendedores = () => {
    const url     = rotas.vendedor;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.vendedor_id, title: lst.vendedor });
        });
        setVendedores(lista);
      }
    })
  }

  const imprimirPDF = () => {
    if (listaAtendimento.length > 0) {
      
      let dados = {
        rede:     sessionStorage.getItem('rede'),
        usuario:  sessionStorage.getItem('usuario'),
        dataI:    form['inicio'],
        dataF:    form['final'],
        lista:    listaAtendimento,
        total:    resumo
      }
  
      try{
        const url     = rotas.atendimento+"pdf/"
        const retorno = rest.post(url, dados);
  
        retorno.then(ret => {
          if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
            let caminho = url.split('/');
            let caminhoPDF = '';
  
            for(let x = 0 ; x < caminho.length -1 ; x++){
              if(caminhoPDF === ''){
                caminhoPDF = caminho[x]; 
              }else{
                caminhoPDF = caminhoPDF + '/' + caminho[x];
              }
            }
            setPathPDF( homepage + '/' + caminhoPDF + ret.path);
            setModalPrint(true);
  
          } else {
            console.log(ret);
            // Swal.fire('Erro', 'Erro na geração da impresão', 'error');
          }
        })
      }catch(err){
        console.log(err)
      }
    }
  }

  const pesquisaSubmit = (e) => {
    e.preventDefault()

    setdivResumo('d-none')
    setLoadingTabela(true)

    const url     = rotas.atendimento
    const retorno = rest.post(url, form)

    try {
      retorno.then(ret => {
        console.log(ret);
        if (ret.success && ret.success == 'S'){
          setListaAtendimento(ret.lista)
          setResumo(ret.total)
          setdivResumo('')
        }else{
          setListaAtendimento([])
          setResumo([])
          if (ret.aviso) {
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setListaAtendimento([])
      setResumo(inicialResumo)
      setLoadingTabela(false)
    }
  }

  useEffect(() => {
    listaLojas()
    listarCategorias()
    listarFornecedores()
    // listarVendedores()
  }, [])
  
  if (loading) {
    return ( <Loading tipo='paginas' /> )
  } else {
    return (
    
      <div className="content" key="585">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA DE ATENDIMENTO</CardTitle>
                </CardHeader>
                <CardBody>

                  <div className="border p-3">
                    <Form onSubmit={pesquisaSubmit}>
                      <Container>
                        <Row>

                          <Col md='4'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                isMulti
                                name          = "lojas"
                                placeholder   = "Selecione a Loja"
                                options       = {lojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0">
                            <AsyncSelect
                              isMulti
                              cacheOptions 
                              defaultOptions 
                              id              = "selectProdutos"
                              name            = "selectProdutos"
                              classNamePrefix = "react-select"
                              placeholder     = "Selecione o Produto"
                              loadOptions        = {pesquisaProduto}
                              onChange           = {onChangeSelect('produtoSelect')}
                              onClick            = {form.produtoSelect ? form.produto_id = form.produtoSelect.id : ''}
                              noOptionsMessage   = {() => "Nenhum produto encontrado"}
                              loadingMessage     = {() => "Buscando..."}
                              formatOptionLabel  = {(opt) => (
                                <div>
                                  <div style={{ fontSize: '13px' }}>{opt.label}</div>
                                  {opt.cod_barras && <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}><i className="ti ti-barcode" style={{ fontSize: '12px', marginRight: '4px' }} aria-hidden="true" />{opt.cod_barras}</div>}
                                </div>
                              )}
                            />
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.inicio}
                                onChange      = {onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.final}
                                onChange      = {onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = 'slecFornecedor'
                                name            = "selectFornecedor"
                                placeholder     = "Selecione o Fornecedor"
                                options         = {fornecedores}
                                onChange        = {onChangeSelect('fornecedorSelect')}
                                onClick         = {form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = "selectCategoria"
                                name            = "selectCategoria"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione a Categoria"
                                options         = {categorias}
                                onChange        = {onChangeSelect('categoriaSelect')}
                                onClick         = {form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md='2' style={{ display: "flex", justifyContent: "center", }}>
                            <FormGroup className="mb-0">
                              <Button
                                color   = "warning"
                                onClick = {imprimirPDF}
                              >
                                IMPRIMIR
                                <i className="nc-icon nc-single-copy-04 pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>
                          
                          <Col md="2">
                            <FormGroup className="mb-0" style={{ display: "flex", justifyContent: "right", }}>
                              <Button 
                              color = "success"
                              type  = 'submit'
                              >
                                Gerar
                                <i className="nc-icon nc-zoom-split pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>

                        </Row>
                      </Container>
                    </Form>

                    <Container className="mt-3">
                      {
                        loadingTabela ?  <Loading tipo='componente' /> 
                        :
                          <BootstrapTable
                            striped
                            keyField          = 'curva_classificacao'
                            data              = {listaAtendimento}
                            columns           = {colunas}
                            noDataIndication  = "Nenhum registro encontrado"
                            // pagination        = {paginationFactory({
                            //                       sizePerPage: 20,
                            //                       hideSizePerPage: true,
                            //                       hidePageListOnlyOnePage: true,
                            //                       showTotal: false,
                            //                     })}
                            rowStyle          = {{ cursor: "pointer" }}                          
                          />
                      }

                      <Row className={divResumo}>
                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-success" />quantidade de atendimento
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "totalQuantidade"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-info"
                                  value     = {resumo['quantidade']}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-warning" />valor total vendido
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "totalVendido"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['valor']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                <span className="form-check-sign bg-danger" />total ticket médio
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "totalTicket"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['ticket']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>
                      </Row>

                    </Container>

                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modalPrint}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
              </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModalPrint(false)}}
              >Fechar
              </Button>
            </Col>
          </Row>
        </Modal>
        
      </div>

    )
  }
}

export default Atendimento
